
module dg.lists {




    class ListController {

        public options: IListOptions;
        public queryManipulator: dg.actions.QueryManipulator;
        //public items: any[];

        $onInit = () => {
          //  if (!this.queryManipulator) {
               // this.queryManipulator = new QueryManipulatorLocal();
           
         //   }
        }

        //$onChanges = (changesObj) => {
        //    if (!this.queryManipulator) {
        //        this.queryManipulator = new QueryManipulatorLocal();
        //        if (this.items) {
        //            this.queryManipulator.setResult({
        //                totalCount: this.items.length,
        //                items: this.items
        //            });
        //        }
        //    }
        //}
    }

    angular.module('dg.lists').component('list', {
        bindings: {
            options: '<',
            queryManipulator: '<',
            //items: '<?'
        },
        controller: ListController,
        templateUrl: '/digmo/src/lists/list.html'
    });
}